import axios from 'axios';

// This will be replaced with your actual API base URL
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:7071/api';

// Create an axios instance with default config
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 10000,
});

// Add a response interceptor for error handling
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        console.error('API Error:', error.response ? error.response.data : error);
        return Promise.reject(error);
    }
);

// API service functions
export const apiService = {
    // Job application
    submitJobApplication: async (formData) => {
        try {
            const response = await api.post('/submitJobApplication', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                timeout: 30000, // 30 seconds
            });
            return response.data;
        } catch (error) {
            console.error('Error submitting job application:', error);
            throw error;
        }
    },

    // Contact form (popup on home page)
    submitContactForm: async (formData) => {
        try {
            const response = await api.post('/submitContactForm', formData);
            return response.data;
        } catch (error) {
            console.error('Error submitting contact form:', error);
            throw error;
        }
    },

    // Contact us form
    submitContactUsForm: async (formData) => {
        try {
            const response = await api.post('/submitContactUsForm', formData);
            return response.data;
        } catch (error) {
            console.error('Error submitting contact us form:', error);
            throw error;
        }
    },
};

export default apiService;